// extracted by mini-css-extract-plugin
export default {"text":"LoginByReferral_text__NGZBX","container":"LoginByReferral_container__eaMER","description":"LoginByReferral_description__GC786"};